import Vue from 'vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ElementUI from 'element-ui';
import API from '@/services/API';
import Armazenamento from '@/services/Armazenamento';
import relatorio from '@/services/relatorio'
import modoRelatorio from   'src/components/Dashboard/Views/Simulacoes/Relatorios/modoRelatorio/modoRelatorio'

Vue.use(ElementUI);

export default {
  name: 'ConfinamentoComparativoSimplesCtrl',
  components: {
    'modo-relatorio':  modoRelatorio
  },
  data () {
    return {
      loader: false,
      loading: false,
      descricoes: null,
      resultados: [],
      entradas: [],
      animais: [],
      lista: [],
      unidades: ['', 'kg/d', '', 'R$/@', '', 'R$', 'R$', '', '', 'R$', '', 'Kg', 'R$'],
      unidades2: ['R$/cab', '', 'Kg', 'R$', 'kg/d', '@', '%', '', 'R$', '', 'R$', '', '', 'R$', 'R$', 'R$', '', 'R$', '', 'R$', ''],
      nomeImagemParceiro: null,
      urlPdf: null
    }
  },
  methods: {
    pegarDescricao (val) {
      let chave = this.descricoes.items[val];
      if (chave) {
        return chave.titulo;
      } else {
        let result = String(val).replace(/([A-Z])/g, ' $1');
        return result.charAt(0).toUpperCase() + result.slice(1);
      }
    },
    pegarUnidade (index) {
      return this.unidades[index];
    },
    pegarUnidade2 (index) {
      return this.unidades2[index];
    },
    reload () {
      location.reload();
    },
    getInitialValues () {
      const animais = API.listar.animais()
      const descricoes = API.listar.descricoes()
      const estados = API.listar.estados()
      return Promise.all([animais, descricoes, estados])
    },
    getSimulation () {
      let lista = this.$router.history.current.params.lista;
      this.lista = lista;
      const indexRelatorioBase = this.lista.findIndex(el => el.simulacaoBase);
      for (let index = 0; index < lista.length; index++) {
        if (index === indexRelatorioBase) {
          lista[index].simulacao_saida.dados.resultados.lucroLiquidoCabComparativo = '-';
          lista[index].simulacao_saida.dados.resultados.custoNutricaoPorArrobaProduzidaComparativo = '-';
          lista[index].simulacao_entrada.dados.gmdKgDComparativo = '-';
          lista[index].simulacao_entrada.dados.custoNutricaoDiarioMedioCabComparativo = '-';
        } else {
          const relatorioSaidaBase = lista[indexRelatorioBase].simulacao_saida.dados.resultados;
          const relatorioSaidaCurr = lista[index].simulacao_saida.dados.resultados;
          const relatorioEntradaBase = lista[indexRelatorioBase].simulacao_entrada.dados;
          const relatorioEntradaCurr = lista[index].simulacao_entrada.dados;
          //  Lucro por cabeça
          relatorioSaidaCurr.lucroLiquidoCabComparativo = this.calcularComparacao(relatorioSaidaBase.lucroLiquido, relatorioSaidaCurr.lucroLiquido, '100')
          // Custo da nutrição por @ produzida,R$/@ => custoNutricacaoPorArrobaProduzida
          relatorioSaidaCurr.custoNutricaoPorArrobaProduzidaComparativo = this.calcularComparacao(relatorioSaidaBase.custoNutricacaoPorArrobaProduzida, relatorioSaidaCurr.custoNutricacaoPorArrobaProduzida, '100')
          // GMD (kg/d)
          relatorioEntradaCurr.gmdKgDComparativo = this.calcularComparacao(relatorioEntradaBase.GMDKgD, relatorioEntradaCurr.GMDKgD, '1000')
          // Custo de nutrição diário médio, R$/cab/dia
          relatorioEntradaCurr.custoNutricaoDiarioMedioCabComparativo = this.calcularComparacao(relatorioEntradaBase.custoDeNutricaoDiarioMedioCABdia, relatorioEntradaCurr.custoDeNutricaoDiarioMedioCABdia, '100')
        }
        // Calculos ganho de peso total e unitário
        const relatorioEntradaCurr = lista[index].simulacao_entrada.dados;
        const relatorioSaidaCurr = lista[index].simulacao_saida.dados.resultados;
        relatorioSaidaCurr.pesoEntradaArroba = (relatorioEntradaCurr.pesoMedioEntradaKgCabBaseOrigem / 30).toFixed(2)
        relatorioSaidaCurr.ganhoDePesoKG = relatorioSaidaCurr.pesoSaidaKg - relatorioEntradaCurr.pesoMedioEntradaKgCabBaseOrigem;
        relatorioSaidaCurr.ganhoDePesoArroba = (relatorioSaidaCurr.pesoSaidaArroba - relatorioSaidaCurr.pesoEntradaArroba).toFixed(2);
        this.resultados.push(lista[index].simulacao_saida.dados.resultados);
        let raca = this.getRaca(lista[index].simulacao_entrada.dados.racaDosAnimais)
        let padraoRacial = this.getRaca(lista[index].simulacao_entrada.dados.racaDosAnimais)
        lista[index].simulacao_entrada.dados.racaDosAnimais = raca && raca[0] ? raca[0].label : 'Não avaliado';
        lista[index].simulacao_entrada.dados.padraoRacialPredominante = padraoRacial && padraoRacial[0] ? padraoRacial[0].label : 'Não avaliado';
        this.entradas.push(lista[index].simulacao_entrada.dados);
      }
      this.loading = false;
      this.exportReport()
    },
    calcularComparacao(v1, v2, grandeza) {
      const casasAposVirgula = grandeza.length - 1;
      const v1Formated = Number(v1.replace(/[^0-9.-]/g, '')).toFixed(casasAposVirgula)
      const v2Formated = Number(v2.replace(/[^0-9.-]/g, '')).toFixed(casasAposVirgula)

      const result = v2Formated - v1Formated;
      return result.toLocaleString({
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    getRaca (index) {
      let racas = [];
      for (let item = 0; item < this.animais.tipos[0].options.length; item++) {
        racas.push(this.animais.tipos[0].options[item])
      }
      for (let item = 0; item < this.animais.tipos[1].options.length; item++) {
        racas.push(this.animais.tipos[1].options[item])
      }
      racas = racas.filter(function (element) {
        return element.value === index
      })
      if (racas.length === 0) {
        return [{label: '-'}]
      }
      return racas
    },
    getPadraoRacial (index) {
      let padrao = [];
      for (let item = 0; item < this.animais.padrao.length; item++) {
        padrao.push(this.animais.padrao[item])
      }
      padrao = padrao.filter(function (element) {
        return element.value === index
      })
      return padrao
    },
    exportReport () {
      let doc = relatorio.comparativo.confinamento.basico.criar(this)
      let pdfBlob = doc.output('blob')
      this.urlPdf = URL.createObjectURL(pdfBlob);
    },
    downloadReport () {
      let doc = relatorio.comparativo.confinamento.basico.criar(this)
      doc.save('comparativo_confinamento_basico.pdf')
    }
  },
  created () {
    this.loading = true
    this.getInitialValues().then(([animais, descricoes, estados]) => {
      this.loading = false
      const assinatura = Armazenamento.assinatura.pegar()
      const valor = assinatura && assinatura.valor
      this.nomeImagemParceiro = valor && valor.cupom && valor.cupom.nomeImagemParceiro
      this.descricoes = descricoes;
      this.animais = animais
      this.pegarDescricao(0);
      return this.getSimulation();
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Simulacoes/Relatorios/Comparativo/Confinamento/SimplesCtrl.js